export function useDocsUrl(path = ""): string {
    const base = (useRuntimeConfig().public.docsUrl as string).replace(
        /\/+$/,
        "",
    );

    return path ? `${base}/${path.replace(/^\/+/, "")}` : base;
}
